export default __webpack_public_path__ + "static/media/CR1.39c6bb7d.png";